import { Card } from "antd";
import styled from "styled-components";
import { theme } from "../../../../theme";

const CustomCard = styled(Card)`
  &.ant-card {
    border-radius: 8px;
    overflow: hidden;
  }
`;

const CardTitle = styled.div`
  ${theme.typo.heading.b18};
  color: ${theme.colors.gray1};
`;

const CardHeader = styled.div`
  ${theme.typo.heading.b14};
  color: ${theme.colors.gray1};
`;

export { CustomCard, CardTitle, CardHeader };
